import { DoorClose, DoorOpen } from '../../icons';

type SidebarCollapseButtonProps = {
	collapsed: boolean;
	onClick: () => void;
};

const SidebarCollapseButton = ({ collapsed, onClick }: SidebarCollapseButtonProps) => {
	return (
		<button
			onClick={onClick}
			className='w-8 h-8 flex items-center justify-center rounded-full hover:bg-secondary-ultra-light transition-colors py-2 px-3'
		>
			<span className='md:hidden'>
				<DoorOpen />
			</span>

			<span className='hidden md:block'>{collapsed ? <DoorOpen /> : <DoorClose />}</span>
		</button>
	);
};

export default SidebarCollapseButton;
